import React from 'react';
import { EmptyResults } from '../utilities/resources';

function EmptyAlert(props) {
  return (
    <div className='emptyResults'>
      <img src={EmptyResults} alt='' />
      <p>{props.message ? props.message : 'No Result Found!'}</p>
    </div>
  );
}

export default EmptyAlert;
